export const safeDateString = (date: Date | null | undefined): string | null => {
  if (!date) return null;
  if (date.toString() === 'Invalid Date') return null;
  const datePart = date.toISOString().split('T')[0];
  return datePart ?? null;
};

export const formattedActivityDate = (date: Date | null | undefined): string | null => {
  if (date) {
    const timestamp = {
      date: new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }),
      time: new Date(date).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      }),
    };
    return `${timestamp.date} · ${timestamp.time}`;
  }
  return null;
};
